/*
 * Copyright (c) Harness Inc.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { useMemo } from 'react'
import { Container } from '../Container/Container'
import { Button } from '../Button/Button'
import { Text } from '../Text/Text'
import { Utils } from '../../core/Utils'
import { Color } from '@harnessio/design-system'
import css from './CodeBlock.css'

export interface CodeBlockProps {
  snippet?: string
  allowCopy?: boolean
  codeToCopy?: string
  format?: string
  lineClamp?: number
  height?: number
}

export function CodeBlock(props: CodeBlockProps) {
  const { snippet = '', allowCopy, codeToCopy, format = 'Text', lineClamp, height } = props

  const floatButton = useMemo<boolean>(() => {
    return lineClamp !== 1 && snippet.split(/\n/).length >= 2
  }, [lineClamp, snippet])

  return (
    <Container
      padding={format === 'pre' ? 'xsmall' : 'small'}
      background={Color.GREY_100}
      margin="none"
      flex
      height={height}
      className={css.codeBlock}>
      {format !== 'pre' && (
        <Text
          color={Color.GREY_350}
          lineClamp={lineClamp}
          font={{
            size: 'normal',
            italic: true
          }}>
          {snippet}
        </Text>
      )}
      {format === 'pre' && <pre>{snippet}</pre>}
      {allowCopy && (
        <Button
          icon="duplicate"
          minimal
          onClick={() => Utils.copy(codeToCopy || snippet)}
          iconProps={{ size: 12 }}
          className={floatButton ? css.floatingCopyButton : undefined}
        />
      )}
    </Container>
  )
}
